const DEFAULT_SORT = 'Sort by';
const SORT = 'sort';
const SORTBY = 'sortby';
const PAGINATION_QUERY = '[page]';
export { DEFAULT_SORT, PAGINATION_QUERY, SORT, SORTBY };
//# sourceMappingURL=constants.js.map